import { t } from '../i18n';
import type { BillingSummary, PaymentProvider } from '@reels/shared/billing';

/** Keep Tribute readiness independent of the Stars launch and document settings. */
export function subscriptionBlockReason({ billing, packageId, provider, online, agreed, busy, waiting, documentsReady }: {
  billing: BillingSummary | null; packageId: string; provider: PaymentProvider; online: boolean;
  agreed: boolean; busy: boolean; waiting: boolean; documentsReady: boolean;
}): string | null {
  if (!online) return t('balance.block.offline');
  if (!billing) return t('balance.block.loading');
  if (busy) return t('balance.block.opening');
  if (waiting) return t('balance.block.waiting');
  const pack = billing.packages.find(p => p.id === packageId);
  if (!pack) return t('balance.block.choose');
  if (provider === 'tribute' ? !billing.tributeEnabled || !pack.tribute : !billing.starsEnabled || !documentsReady) {
    return t(provider === 'tribute' ? 'balance.block.tributeUnavailable' : 'balance.block.starsUnavailable');
  }
  const sub = billing.subscription;
  if (sub && (sub.provider ?? 'stars') !== provider) return t('balance.block.switchToTribute');
  if (sub?.provider === 'tribute' && (sub.changeRequiresCancellation ?? !sub.cancelled)) return t('balance.block.tributeActive');
  if (sub && packageId === sub.packageId) {
    return t('balance.block.samePlan');
  }
  if (!agreed) return t('balance.block.agreeSub');
  return null;
}
